import { lazyScheduleRows } from 'owa-mail-triage-action';
import { getSelectedTableViewId, getSelectedTableView, TableQueryType } from 'owa-mail-list-store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { OwaDate } from 'owa-datetime';
import createSnoozeSubMenu from 'owa-mail-datepicker/lib/utils/createSnoozeSubMenu';
import {
    IContextualMenuProps,
    IContextualMenuItem,
    DirectionalHint,
} from 'office-ui-fabric-react/lib/ContextualMenu';
import getTxpSnoozeDateOptions from 'owa-txp/lib/utils/view/getTxpSnoozeDateOptions';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import * as React from 'react';
import loc from 'owa-localize';
import { HelpMeRememberMenuText, SnoozeSubMenuText } from 'owa-txp/lib/strings.locstring.json';
import { isDeepLink } from 'owa-url';

export interface SnoozeSubMenuProps {
    dueDate: string;
    calendarButtons: IContextualMenuItem[];
    logSnoozeDatapoint: (isCustomDateChosen: boolean) => void;
}

const styles = require('./SnoozeSubMenu.scss');

const SnoozeSubMenu = (snoozeSubMenuProps: SnoozeSubMenuProps) => {
    const tableView = getSelectedTableView();
    const { dueDate, calendarButtons } = snoozeSubMenuProps;
    let snoozeSubMenu: IContextualMenuProps | undefined;
    const reminderContextMenu: IContextualMenuProps = {
        items: calendarButtons,
    };
    let isInsideInboxOrScheduled = false;
    const folderName = tableView?.tableQuery && folderIdToName(tableView.tableQuery.folderId);
    const { logSnoozeDatapoint } = snoozeSubMenuProps;

    if (
        tableView?.tableQuery?.type == TableQueryType.Folder &&
        (folderName == 'inbox' || folderName == 'scheduled')
    ) {
        isInsideInboxOrScheduled = true;
    }

    const onSnoozeItemClicked = async (date?: OwaDate, isCustomDateChosen?: boolean) => {
        const tableViewId = getSelectedTableViewId();
        const tableView = getSelectedTableView();
        const rowKeys = tableView && [...tableView.selectedRowKeys.keys()];

        if (tableViewId && rowKeys) {
            const scheduleRows = await lazyScheduleRows.import();
            scheduleRows(rowKeys, tableViewId, 'ContextMenu' /* actionSource */, date);

            isCustomDateChosen !== undefined && logSnoozeDatapoint(isCustomDateChosen);
        }
    };

    if (!isDeepLink() && isInsideInboxOrScheduled) {
        const dates = getTxpSnoozeDateOptions(dueDate);
        snoozeSubMenu = createSnoozeSubMenu(
            onSnoozeItemClicked,
            dates,
            DirectionalHint.bottomLeftEdge
        );
    }

    if (snoozeSubMenu) {
        reminderContextMenu.items = reminderContextMenu.items.concat({
            key: loc(SnoozeSubMenuText),
            text: loc(SnoozeSubMenuText),
            items: snoozeSubMenu.items,
        });
    }

    return (
        <CommandBarButton
            text={loc(HelpMeRememberMenuText)}
            menuProps={reminderContextMenu}
            className={styles.snoozeSubMenuButton}
        />
    );
};

export default SnoozeSubMenu;
